export enum SitesRouteNames {
  SITES_ROOT = 'SitesRoot',
  SITES_LIST = 'SitesRoot/Sites',
  SITE_DETAILS = 'SitesRoot/Sites/Site/Details',
  SITE_OVERVIEW = 'SitesRoot/Sites/Site/Overview',
  SITE_MENU_HOURS = 'SitesRoot/Sites/Site/Details/MenuHours',
  SITE_PICKUP_DETAILS = 'SitesRoot/Sites/Site/PickupDetails',
  SITE_DROPOFF_DETAILS = 'SitesRoot/Sites/Site/DropoffDetails',
  SITE_REPORTING = 'SitesRoot/Sites/Site/Reporting',
  SITE_SALES_CHANNEL = 'SitesRoot/Sites/Site/SalesChannel',
  SITE_KDS = 'SitesRoot/Sites/Site/KDS',
  SITE_FINANCIAL_CONFIG = 'SitesRoot/Sites/Site/FinancialConfig',
  SITE_STATION_SCHEDULE = 'SitesRoot/Sites/Site/StationSchedule',
  SITE_BUSINESS_UNIT = 'SitesRoot/Sites/Site/BusinessUnit',
  SITE_STATION = 'SitesRoot/Sites/Site/Station',
  SITE_STATION_NEXTEP = 'SitesRoot/Sites/Site/Station/Nextep',
  SITE_STATION_APP_CONFIG = 'SitesRoot/Sites/Site/Station/AppConfig',
  SITE_SETTINGS = 'SitesRoot/Sites/Site/Settings',
  SITE_STATION_INTEGRATION = 'SitesRoot/Sites/Site/Station/Integration',
  SITE_STATION_AGILYSYS = 'SitesRoot/Sites/Site/Station/Agilysys',
  SITE_STATION_AGILYSYS_DOD = 'SitesRoot/Sites/Site/Station/AgilysysDoD',
  SITE_STATION_VOLANTE = 'SitesRoot/Sites/Site/Station/Volante',
  SITE_STATION_MASHGIN = 'SitesRoot/Sites/Site/Station/Mashgin',
  SITE_STATION_CENTRIC_HUB = 'SitesRoot/Sites/Site/Station/CentricHub',
  SITE_RECOMMENDATION_DETAILS = 'SitesRoot/Sites/Site/RecommendationDetails',
  SITE_CENTRIC_POS = 'SitesRoot/Sites/Site/CentricPOS',
  SITE_STATION_TRANSACT = 'SitesRoot/Sites/Site/Station/Transact',
  SITE_STATION_GRUBHUB = 'SitesRoot/Sites/Site/Station/Grubhub',
  SITE_STATION_RYST = 'SitesRoot/Sites/Site/Station/Ryst',
}
